import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Swap the JWT + stored user to `targetRole` via /api/auth/switch-role when
 * the user is currently browsing under a different role. No-ops when the
 * role already matches, is empty, or the switch is rejected (user simply
 * stays where they are). Returns true when a switch happened.
 */
export async function switchRoleIfNeeded(targetRole) {
  const cleaned = (targetRole || '').trim().toLowerCase();
  if (!cleaned) return false;
  const storedUser = (() => {
    try { return JSON.parse(window.localStorage.getItem('user') || '{}'); } catch { return {}; }
  })();
  if ((storedUser.role || '') === cleaned) return false;
  const token = window.localStorage.getItem('token');
  if (!token) return false;
  try {
    const res = await axios.post(
      `${API}/auth/switch-role`,
      { target_role: cleaned },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    window.localStorage.setItem('token', res.data.access_token);
    window.localStorage.setItem('user', JSON.stringify(res.data.user));
    return true;
  } catch {
    return false;
  }
}
